import { AnimatePresence, LayoutGroup, motion } from "motion/react"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{
  className?: string
}>

export function AnimatedSearchCards(props: Props) {
  return (
    <LayoutGroup>
      <motion.div data-animated-search-cards className={props.className}>
        {props.children}
      </motion.div>
    </LayoutGroup>
  )
}
